import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UserService } from './services/user.service';
import { LoaderService } from './services/loader.service';
import { ShopService } from './services/shop.service';
import { HttpClient } from '@angular/common/http';;
import { DomSanitizer } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";

@Component({
  selector: 'app-helpdeskreply',
  templateUrl: '/helpdeskreply.html?v=20260305',
  styles: ['.imgPreview {width: 8em; height: 8em; background-size: contain; background-repeat: no-repeat; background-position: center} .myForm { gap: 0.5em; justify-content: center; .flxRow { display: flex;  flex-direction: row; align-items: center; padding: 0.5em 0; label { min-width: 8.5em; text-align: left; }} } ']
})

export class HelpDeskReplyComponent {

  @Input() caseNum: string = "";
  @Input() caseId: string = "";
  @Input() shopId: string = "";

  @Output() finished: EventEmitter<boolean> = new EventEmitter<boolean>();
  loadingFiles = false;

  public outputFinished() {
    this.finished.emit(true);
  }

  subscriptions: Subscription[] = []
  helpDeskForm = false;
  myForm: FormGroup;
  myDataSubs: any;
  myUser: any;
  myDataShops: any = null;
    myDataShopsAll: any = [];
    loadingAutocomplete = true;
    dspOrderNumber = false;
    dspCampaignName = false;
    dspHandS = false;
    myMessage = "";
    myCss = "";
    submitForm = false;
    dspPhone = false;
    dspLogged = false;
  stepDisplay = 1;

  userName: string;
  store: any;
  sla: string = "";




 

  constructor(private userService: UserService
    , private loaderService: LoaderService
    , private shopService: ShopService
    , public http: HttpClient
    , private fb: FormBuilder
    , private sanitizer: DomSanitizer  ) {

    this.loadForm()

   

  }

    loadForm(myUser: any = null) {
        //this.myFile = { "Filename": "", "Title": "", "Type": "" }; //clear this out each time
        this.dspUploadPending = false;
        this.myForm = this.fb.group({
           myFormName: ['', Validators.required],
            myFormEmail: [{ value: (myUser ? myUser.Email : ''), disabled: true }, [Validators.required, Validators.email]],
            myFormDetails: ['', Validators.required],
            myFormFiles: [''],
            myFilesPreview: [''],
            fileslist: this.fb.array([]),
            files: this.fb.array([])
        });

      this.myForm.markAsTouched();
      this.myForm.markAsDirty();
    }

  

    public findInvalidControls() {
        const invalid = [];
        const controls = this.myForm.controls;
        for (const name in controls) {
            if (controls[name].invalid) {
                invalid.push(name);
            }
        }
        return invalid;
  }





    myTxtAreaHeight = "200px"
    txtAreaSize(event: any) {
        let textArea = event.target; //this.myForm.controls['myFormDetails']
        this.myTxtAreaHeight = (textArea.scrollHeight < 250 ? 250 : textArea.scrollHeight) + "px"
    }

    dspAddPicMessage = false;
    myMessageSendFiles = "";
    mySubmissionData: any;
  myResponseTxt = "";

    onSubmit(event: any) {
        this.dspAddPicMessage = false
        let doSumbit = true;


        if (doSumbit) { 
            this.loaderService.emitChange(true);
            this.submitForm = true;
            //this.myMessage = "Please wait whilst we upload any attachments and retrieve your case reference.";
          this.myMessage = "Please wait whilst we send your follow up";
          this.myResponseTxt = "";
            //let myVal = this.myForm.get("myFormShop").value
            this.mySubmissionData = {
                "Brand": "Specsavers", //this.myForm.get("myFormBrand").value,
              "Case": this.caseNum,
              "CaseId": this.caseId,
              "shopId": this.shopId,
                "Name": this.myForm.get("myFormName").value,
                "Email": this.myForm.get("myFormEmail").value,
                "Details": this.myForm.get("myFormDetails").value,
                "IncludesAttachments": (this.myFilesPreview.length > 0 ? this.myFilesPreview.length : 0),
               
            }
 
          this.http.post<any>("/HelpDesk/AddReply", this.mySubmissionData)
            .subscribe({
              next: (res) => {
                this.loaderService.emitChange(false);

                try {
                  if (res.Result !== "success") {
                    if (res.Message) {
                      this.myMessage = res.Message;
                    } else {
                      this.myMessage = res[0]?.message;
                    }
                    this.myCss = "error";
                  } else {
                    this.outputFinished()


                    if ((this.myFilesPreview?.length ?? 0) === 0) {
                      this.myMessage = res.Message;
                    } else {
                      const mySubmissionDataFiles = {
                        //AttachedFiles: { AttachedFiles: this.myFilesPreview },
                        AttachedFiles: JSON.stringify({ "AttachedFiles": this.myFilesPreview }),
                        QueryResponseId: res.QueryResponseId
                      };

                      this.myMessage = res.Message;

                      this.stepDisplay = 1


                      this.myMessageSendFiles = "Please wait a moment longer whilst we submit your files.";
                      this.myCss = "success";
                      this.loadingFiles = true;

                      this.loaderService.emitChange(true);

                      this.http.post<any>("/HelpDesk/AddQuery25Files", mySubmissionDataFiles)
                        .subscribe({
                          next: (res2) => {
                            this.loaderService.emitChange(false);
                            this.myFilesPreview = [];

                            try {
                              if (res2.Result !== "success") {
                                if (res2.Message) {
                                  this.myMessageSendFiles = res2.Message;
                                } else {
                                  this.myMessageSendFiles = res2[0]?.message;
                                }
                                this.myCss = "error";
                              } else {
                                this.myMessageSendFiles = res2.Message + " " + res2.Attachments;
                                this.myCss = "success";
                              }
                              this.loadingFiles = false;
                            } catch (e) {
                              this.myMessage = res2 + ".";
                              this.loadingFiles = false;
                            }
                          },
                          error: (error) => {
                            this.myMessage = error + ".";
                            this.loadingFiles = false;
                          }
                        });
                    }
                  }
                } catch (e) {
                  this.myMessage = res + ".";
                }
              },
              error: (error) => {
                this.myMessage = error + ".";
              }
            });


           
           
        }
    }



  


    //BEGIN FILE UPLOAD

    previewPic(myPic: string) {
        if (myPic === "no_image") {
            myPic = null;
        }
        return this.sanitizer.bypassSecurityTrustStyle("url(\"" + myPic + "\")");
    }

    removeFile(i: number) {
        //this.myFiles.splice(i, 1);
        this.myFilesPreview.splice(i, 1);

        //this.dspTooLarge = false;
        //let myFilesCombinedSize = 0;
        //this.myFilesPreview.forEach((itm: any) => {
        //    myFilesCombinedSize += itm.Size;
        //});

        //if (myFilesCombinedSize > this.maxFileSize) {
        //    //this.myLargeFiles.push({ "file": fileData.name, "size": fileData.size });
        //    this.dspTooLarge = true
        //}

        this.getFileSizes();

    }

    getFileSizes() {
   
        this.dspTooLarge = false;
        let myFilesCombinedSize = 0;
        this.myFilesPreview.forEach((itm: any) => {
            myFilesCombinedSize += itm.Size;
        });

        if (myFilesCombinedSize > this.maxFileSize) {
            this.dspTooLarge = true
        }

    }

    //myFile = { "Filename": "", "Title": "", "Type": "" }; //clear this out each time
    dspUploadPending = false;

    myFiles: string[] = [];
    myFilesPreview: any = [];
    //fileData: File = null;
    myMimeTypes = [""
        ,"image/jpeg"
        ,"image/png"
        ,"application/pdf"
        ,"text/csv"
        ,"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        , "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
        , "video/mp4"
        , "video/webm"
        , "video/ogg"
        , "video/x-msvideo"
        , "video/quicktime"
        , "video/x-flv"
        , "video/x-ms-wmv"
    ]

    getBase64(file: any) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
                let encoded = reader.result.toString().replace(/^data:(.*,)?/, '');
                if ((encoded.length % 4) > 0) {
                    encoded += '='.repeat(4 - (encoded.length % 4));
                }
                resolve({ "Clean": encoded, "Meta": reader.result.toString() });
            };
            reader.onerror = error => reject(error);
        });
    }

   
   // myLargeFiles: any = [];
    maxFileSize = 40 * 1024 * 1024;
    dspTooLarge = false;

     bytesToMB(bytes: number): number {
    const megabytes = bytes / (1024 * 1024); // Convert bytes to MB
        return Math.round(megabytes); // Round to 0 decimal places
    }
    
    fileSelectHandler(event: any) { //this one for the fiel select// could deal with multiple files (restricted by input)
        this.myForm.markAsTouched();
        this.myForm.markAsDirty();
        this.myFiles = [];

       // this.myLargeFiles = []

        let myFilesCombinedSize = 0;

        for (let x: number = 0; x < event.target.files.length; x++) {
            //preview // we want to encourage the upload so no preview
            let fileData: File = <File>event.target.files[x];
            let mimeType: string = fileData.type;

            let myFile = null;
         
            if (this.myMimeTypes.findIndex(x => x === mimeType) > -1) {

               // myFilesCombinedSize += fileData.size

                //if (fileData.size > this.maxFileSize) {
                 //   this.myLargeFiles.push(fileData.name);
                //}

                //this.myLargeFiles.push({ "file": fileData.name, "size": fileData.size / 1024+ 'MB' });

               // if (myFilesCombinedSize > this.maxFileSize) {
                    //this.myLargeFiles.push({ "file": fileData.name, "size": fileData.size });
                  //  this.dspTooLarge = true
                //}
     
                this.getBase64(fileData).then(
                    (data: any) => {
                        if (mimeType.match(/image\/*/) == null) {
                            myFile = { "Filename": event.target.files[x].name, "Title": event.target.files[x].name, "Size": event.target.files[x].size , "Type": event.target.files[x].type, "File": "", "Base64": data.Clean, "Display": "File" };
                        }
                        else {
                            myFile = { "Filename": event.target.files[x].name, "Title": event.target.files[x].name, "Size": event.target.files[x].size, "Type": event.target.files[x].type, "File": data.Meta, "Base64": data.Clean, "Display": "Image" };
                        }
                        this.myFilesPreview.push(myFile);

                        this.getFileSizes() 
                    }
                );


                
            }
            else {
                return;//nothing
            }



        }


        

        this.dspUploadPending = true;
    }



    //END FILE UPLOAD
    public ngOnInit(): any {
      this.submitForm = false;
      this.stepDisplay = 1
      
      //this.sla = this.Sla
      this.subscriptions.push(this.userService.profile().subscribe((data: any) => {
            this.myUser = data;
        })
        )
      //this.myDataCategories = this.myDataCategoriesNormal; // (this.shop.FM == 'true' ? this.myDataCategoriesFM: this.myDataCategoriesNormal)
    }

    public ngOnDestroy() {
        this.subscriptions.forEach((subscription) => { subscription.unsubscribe(); });
    }

}
